import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { ModalController } from 'ionic-angular';
import { GriffePage } from '../griffe/griffe';
import { ColorPage } from '../color/color';
import { QuickviewPage } from '../quickview/quickview';

@Component({
  selector: 'page-dekor',
  templateUrl: 'dekor.html',
})
export class DekorPage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dichtungen: string;
dekorfarbe: string;
selectedColor: any;
selectedColor2: any;
outColorIn: any;
outColorOut: any;
selectedDichtung: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public alertCtrl: AlertController, public popoverCtrl: PopoverController) {
  
    this.dichtungen = "schwarz";
  
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');
    console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide); 
  
  }
  
    presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen, windowlong: this.windowlong, windowwide: this.windowwide }
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
  
   selectDichtung(dichtung) {
   this.dichtungen = dichtung;
   console.log(this.dichtungen); 
   }
  
   presentModalColors() {
    let colorModal = this.modalCtrl.create(ColorPage, {
      'selectedColor': this.outColorIn,
    });
    colorModal.onDidDismiss(data => {
      this.outColorIn = data.color;
    });
    colorModal.present(); 
  }
  
     presentModalColors2() {
    let colorModal = this.modalCtrl.create(ColorPage, {
      'selectedColor': this.outColorOut,
    });
    colorModal.onDidDismiss(data => {
      this.outColorOut = data.color;
    });
    colorModal.present();
  }
 
  ionViewDidLoad() {
    console.log('ionViewDidLoad FenstertypPage');
  }
  
    ionViewWillEnter() : void
   {

   }
   
    clickdekor() {
    /*if (this.outColorIn == null || this.outColorIn == "undefined" || this.outColorIn == '' ) {
     this.alertCtrl.create({
            title: 'Achtung',
            message: 'Sie haben keine Innen Dekor Farbe ausgewählt. Standardgemäss wird weiss angewendet. Falls Sie dies nicht wünschen, wählen Sie jetzt die Farbe aus.',
            buttons: ['OK']
          }).present();
          return;
    }     
    if (this.outColorOut == null || this.outColorOut == "undefined" || this.outColorOut == '' ) {
     this.alertCtrl.create({
            title: 'Achtung',
            message: 'Sie haben keine Aussen Dekor Farbe ausgewählt. Standardgemäss wird weiss angewendet. Falls Sie dies nicht wünschen, wählen Sie jetzt die Farbe aus.',
            buttons: ['OK']
          }).present();
          return;
    } else*/
    this.navCtrl.push(GriffePage, {
    typeopen: this.typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype,
    windowlong: this.windowlong,
    windowwide: this.windowwide,
    dichtungen: this.dichtungen,
    outColorIn: this.outColorIn,
    outColorOut: this.outColorOut
    });
  }
   

}



// WEBPACK FOOTER //
// ./src/pages/dekor/dekor.ts